import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { TransportType } from '../../../../../../../components/transport-details/transport-details-model';
import { FilterAdministrationContext } from '../../../../filter-administration.context';
import { FilterCondition } from '../../../../filter-administration.model';
import { FilterDetailsComponent } from '../../../../filter-details-component.model';

@Component({
  selector: 'app-transport-type-editor',
  templateUrl: './transport-type-editor.component.html',
  styleUrls: ['./transport-type-editor.component.scss']
})
export class TransportTypeEditorComponent implements OnInit, OnDestroy, FilterDetailsComponent {

  transportTypes = new Array<TransportType>();

  condition: FilterCondition;

  filterAdministrationContext: FilterAdministrationContext;
  filterAdministrationContextSubscription: Subscription;

  detailsFormGroup = new FormGroup({});

  constructor(
  ) {

    for (const key of Object.keys(TransportType)) {
      this.transportTypes.push(TransportType[key]);
    }

    this.detailsFormGroup.addControl('transportType', new FormControl(TransportType.TRANSPORT, []));

    this.detailsFormGroup.valueChanges.subscribe(
      value => {
        if (this.detailsFormGroup.dirty) {
          this.condition.data.transportType = this.detailsFormGroup.controls.transportType.value;
          this.filterAdministrationContext.getFilter().dirty = true;
        }
      }
    );

  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    if (this.filterAdministrationContextSubscription != null) {
      this.filterAdministrationContextSubscription.unsubscribe();
    }
  }

  setFilterAdministrationContext(filterAdministrationContext: FilterAdministrationContext) {
    this.filterAdministrationContext = filterAdministrationContext;
    this.condition = this.filterAdministrationContext.getSelectedFilterCondition();
    this.resetForm();
    this.filterAdministrationContextSubscription = this.filterAdministrationContext.contextChange$.subscribe(
      change => {
        try {
          if (change.key === 'selected-filter-condition-changed') {
            this.condition = this.filterAdministrationContext.getSelectedFilterCondition();
            this.resetForm();
          }
        } catch (error) {
          console.log(error);
        }
      }
    );
  }

  private resetForm() {
    this.detailsFormGroup.reset({ transportType: this.condition.data.transportType || TransportType.TRANSPORT });
  }

}
